import type { SimConfig } from '../config/simConfig';
import type { Vec2 } from '../types';

// Expected-goals estimate (§8.1): xG = clamp01(XG_SCALE · exp(−dist/XG_DIST) · max(0, cosθ_offCenter)),
// where cosθ_offCenter = |dx|/dist is how central the shot is (1 = straight on, 0 = from the byline). Pure.

export function xg(pos: Vec2, goalX: number, cfg: SimConfig): number {
  const dx = goalX - pos.x;
  const dy = -pos.y; // toward the goal centre (y = 0)
  const dist = Math.hypot(dx, dy);
  if (dist < 1e-6) return cfg.ai.XG_SCALE;
  const cosOff = Math.max(0, Math.abs(dx) / dist);
  const g = cfg.ai.XG_SCALE * Math.exp(-dist / cfg.ai.XG_DIST) * cosOff;
  return g < 0 ? 0 : g > 1 ? 1 : g;
}
